import qs from "qs";

type CampaignFollowQuery = {
  action?: {
    follow_campaign?: CampaignFollowQueryConfig;
  };
};

type CampaignFollowQueryConfig = {
  campaign: string;
};

export function parseConfigFromQueryAction(query: string) {
  const parsedQueryString = qs.parse(query, {
    ignoreQueryPrefix: true,
  }) as CampaignFollowQuery;
  const parsedConfig = parsedQueryString.action?.follow_campaign;
  if (!parsedConfig) return;

  return parsedConfig;
}

export function queryFromConfig(config: CampaignFollowQueryConfig) {
  const query: Required<CampaignFollowQuery> = {
    action: {
      follow_campaign: config,
    },
  };
  return qs.stringify(query, { arrayFormat: "comma" });
}
